import type RegistrationService from 'shared/login/registration.service';
import type LoginService from 'shared/login/login.service';
import type {Auth, Department} from 'typings/portaro.be.types';
import {DepartmentEditationMode} from 'typings/portaro.be.types';
import type DepartmentDataService from '../../features/departments/services/department.data-service';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';

export default class DepartmentCreatedDialogController {
    public static controllerName = 'DepartmentCreatedDialogCtrl';

    private closeDialogFunction: () => any;

    /*@ngInject*/
    constructor(private registrationService: RegistrationService,
                private loginService: LoginService,
                private currentAuth: Auth,
                private currentDepartment: Department,
                private departmentDataService: DepartmentDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService,
                private SERVER_URL: string) {
    }

    public init(closeDialogFunction: () => any): void {
        this.closeDialogFunction = closeDialogFunction;
    }

    public getHost(): string {
        return this.SERVER_URL
            .replace('http://', '')
            .replace('https://', '');
    }

    public async activateDepartment() {
        const actionResponse = await this.departmentDataService.activate(this.currentDepartment, this.currentAuth.activeUser);
        this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        this.closeDialogFunction();
    }

    public async registerWithEditorAccount() {
        await this.registrationService.savePersonByForm({}, {});
        this.closeDialogFunction();
    }

    public async loginAndAddEditorAccount() {
        await this.loginService.login();
        await this.addEditorAccount();
        this.closeDialogFunction();
    }

    public async addEditorAccount() {
        await this.registrationService.savePersonWithDepartmentByForm(
            null,
            {},
            {department: this.currentDepartment, departmentEditationMode: DepartmentEditationMode.MERGE_DUPLICATES_OR_APPEND},
            {department: this.currentDepartment, departmentEditationMode: DepartmentEditationMode.MERGE_DUPLICATES_OR_APPEND}
        );

        this.closeDialogFunction();
    }
}
